export const FUEL_CHANGES_DROPDOWN_ITEMS: string[] = ['Fuel Increases And Decreases Areas', 'Fuel Increase Areas', 'Fuel Decrease Areas'];

// The items above are stable filter values (compared in map-filter.helper.ts and stored in CommonMapService).
// They are never shown as-is: the map component renders the translated label for each value.
export const FUEL_CHANGES_DROPDOWN_LABEL_KEYS: Record<string, string> = {
  'Fuel Increases And Decreases Areas': 'fuelDashboard.map.filters.all',
  'Fuel Increase Areas': 'fuelDashboard.map.filters.increases',
  'Fuel Decrease Areas': 'fuelDashboard.map.filters.decreases',
};